import { Avatar, Button, Stack, Typography } from '@mui/material';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { GrayTrash, UploadedFile, Watch } from 'Images';
import { IUploadedFile } from 'Hooks/useDocumentUpload';
import { UploadedSuccessful } from './UploadedSuccessful';

export type { IUploadedFile };

interface IUploadedFileItem {
  file: IUploadedFile;
  onDeleteFile?: (fileId: string) => void;
  onViewFile?: (fileId: string) => void;
}

export const UploadedFileItem = ({
  file,
  onDeleteFile,
  onViewFile,
}: IUploadedFileItem) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);
  const isDesktop = useIsDesktop();

  return (
    <Stack
      sx={{
        flexDirection: isDesktop ? 'row' : 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: '1px solid',
        borderColor: 'primary.shade_100',
        borderRadius: '16px',
        p: '16px 20px',
        gap: '20px',
        maxWidth: '100%',
      }}
    >
      <Stack
        sx={{
          alignItems: 'center',
          gap: '16px',
          width: isDesktop ? 'fit-content' : '100%',
          flexDirection: 'row',
        }}
      >
        <Avatar
          src={UploadedFile}
          alt={''}
          sx={{
            width: '48px',
            height: '48px',
          }}
        />
        <Stack gap='10px' height='100%' justifyContent='center' maxWidth='100%'>
          <Typography
            sx={{
              fontSize: '16px !important',
              fontWeight: '600 !important',
              lineHeight: '20px !important',
              maxWidth: isDesktop ? '312px' : '19ch',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {file.name}
          </Typography>
          {isDesktop && <UploadedSuccessful />}
        </Stack>
      </Stack>
      {!isDesktop && <UploadedSuccessful />}
      <Stack
        sx={{
          alignItems: 'center',
          gap: '12px',
          width: isDesktop ? 'fit-content' : '100%',
          flexDirection: 'row',
        }}
      >
        <Button
          fullWidth={!isDesktop}
          sx={{
            p: '6px 13.5px',
            bgcolor: '#E7EDFF',
            borderRadius: '8px',
          }}
          onClick={() => onViewFile?.(file.id)}
        >
          <Avatar src={Watch} alt={''} sx={{ width: '20px', height: '20px' }} />
          <Stack>
            <Typography variant='body5' color='#344266'>
              {dictionary.uploadFile.watch}
            </Typography>
          </Stack>
        </Button>
        <Button
          fullWidth={!isDesktop}
          sx={{
            p: '6px 13.5px',
            bgcolor: '#F6F8FE',
            borderRadius: '8px',
          }}
          onClick={() => onDeleteFile?.(file.id)}
        >
          <Avatar
            src={GrayTrash}
            alt={''}
            sx={{ width: '20px', height: '20px' }}
          />
          <Typography variant='body5' color='#344266'>
            {dictionary.uploadFile.deleteFile}
          </Typography>
        </Button>
      </Stack>
    </Stack>
  );
};
